import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { allFeatureIds, featureMapForSpecimen } from './specimenFeatures';
import type { FeatureValue } from './specimenFeatures';
import { getTaxon } from './taxonomyDatabase';

interface FeatureMatrixProps {
  specimenIds: string[];
  observations: Record<string, Record<string, FeatureValue>>;
}

const display = (value: FeatureValue | undefined) => value === undefined ? '—' : typeof value === 'boolean' ? (value ? 'Present' : 'Absent') : String(value).replaceAll('-', ' ');

const FeatureMatrix: React.FC<FeatureMatrixProps> = ({ specimenIds, observations }) => {
  const features = allFeatureIds().filter((featureId) => specimenIds.some((id) => featureId in featureMapForSpecimen(id)));
  return <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 1 }}>
    <Typography variant="subtitle1" fontWeight={800}>Observable feature matrix</Typography>
    <Typography variant="caption" color="text.secondary">Recorded observations fill the matrix; unobserved traits remain blank, not “absent”.</Typography>
    <TableContainer sx={{ maxHeight: 300, mt: 1 }}><Table size="small" stickyHeader aria-label="Specimen observable feature matrix"><TableHead><TableRow><TableCell>Specimen</TableCell>{features.map((feature) => <TableCell key={feature}>{feature}</TableCell>)}</TableRow></TableHead>
      <TableBody>{specimenIds.map((id) => <TableRow key={id}><TableCell>{getTaxon(id).commonName}</TableCell>{features.map((feature) => <TableCell key={feature}>{display(observations[id]?.[feature])}</TableCell>)}</TableRow>)}</TableBody>
    </Table></TableContainer>
  </Paper>;
};

export default FeatureMatrix;
